import { Box, Button, Tooltip } from "@mui/material";
import { GridSortItem } from "@mui/x-data-grid";
import { useState } from "react";
import { getRealm } from "../../../../AuthProvider";
import CustomDataGridV2 from "../../../../components/CustomDataGridV2";
import Flex from "../../../../components/Flex";
import DeleteModal, {
  useDeleteDisClosure,
} from "../../../../components/app/DeleteModal";
import useDisclosure from "../../../../hooks/use-disclosure";
import { useQueryParams } from "../../../../hooks/use-query-param";
import { usePatientIntakeFormList } from "../../../../queries/patient-portal/forms/use-patient-intake-form-list";
import { formatDate } from "../../../../utils/date-time-utility";
import {
  DEF_PAGINATION,
  DGT_Pagination,
  applyDefaultColumnSettings,
} from "../../../../utils/utils";
import UpdatePatientIntakeForm from "./UpdatePatientIntakeForm";

const PatientForms = ({ publicView }: { publicView?: boolean }) => {
  const user = sessionStorage.getItem("user");
  const patientData: any = user ? JSON.parse(user) : undefined;
  const isEmailed = useQueryParams("isEmailed");
  const patientId = useQueryParams("patientId");

  const [formView, setFormView] = useState<"submit" | "view">("submit");

  const formDisclosure = useDisclosure(false);

  const deleteFormDisclosure = useDeleteDisClosure();
  const [pagination, setPagination] = useState<DGT_Pagination>(DEF_PAGINATION);
  const [gridSorting, setGridSorting] = useState<GridSortItem[]>([]);

  const hostNameArr = location.hostname?.split(".");
  const xTENANTID = getRealm(hostNameArr);

  const { data: intakeForms } = usePatientIntakeFormList({
    patientUuid: isEmailed ? patientId : patientData?.uuid,
    pagination,
    gridSorting,
    isPublic: publicView,
    xTENANTID: publicView ? xTENANTID : undefined,
  });

  const COLUMNS = applyDefaultColumnSettings<any>([
    {
      field: "formName",
      headerName: "Form Name",
      flex: 0.6,
      width: 170,
      renderCell: ({ value }) => (
        <Tooltip title={value?.length > 18 ? value : ""}>
          {value || "-"}
        </Tooltip>
      ),
    },
    {
      field: "sendBy",
      headerName: "Sent By",
      flex: 0.5,
      width: 170,
      renderCell: ({ value }) => value || "-",
    },
    {
      field: "sendOn",
      headerName: "Sent On",
      flex: 0.6,
      width: 180,
      renderCell: ({ value }) => (value ? formatDate(value) : "-"),
    },
    {
      field: "submittedOn",
      headerName: "Submitted On",
      flex: 0.5,
      width: 170,
      renderCell: ({ value }) => (value ? formatDate(value) : "-"),
    },
    {
      field: "Action",
      width: 120,
      align: "center",
      headerAlign: "center",
      hideSortIcons: true,
      renderCell: ({ row }) => {
        const isViewType = !!row?.submittedOn;
        return (
          <Button
            sx={{ width: "100px" }}
            variant={isViewType ? "outlined" : "contained"}
            onClick={() => {
              setFormView(isViewType ? "view" : "submit");

              formDisclosure.open(row);
            }}
          >
            {isViewType ? "View" : "submit"}
          </Button>
        );
      },
    },
  ]);

  //   function archiveHandler<T>(value: boolean, id: T) {
  //     return archive({
  //       id: id?.toString() ?? "",
  //       status: value,
  //       xTENANTID: localStorage.getItem("realm") ?? undefined,
  //     }).then((res) => {
  //       refetch();
  //       return res;
  //     });
  //   }

  return (
    <Flex width={"calc(100vw - 256px)"} p={3} flexDirection={"column"}>
      {/* todo while need feat archive form*/}
      <DeleteModal
        w="380px"
        open={deleteFormDisclosure.opened}
        onClose={deleteFormDisclosure.close}
        id={deleteFormDisclosure.deleteId}
        onConfirmation={() => new Promise(() => {})}
        // onConfirmation={(id) => archiveHandler(true, id)}
        content={"You want to delete this Form"}
      />

      <UpdatePatientIntakeForm
        isViewForm={formView === "view"}
        disclosureHost={formDisclosure}
        publicView={publicView}
      />

      <Box bgcolor={"white"} height={"100%"}>
        <CustomDataGridV2
          getRowId={(row) => row?.uuid}
          rows={intakeForms?.data?.content ?? []}
          rowCount={intakeForms?.data?.page?.totalElements ?? 10}
          columns={COLUMNS}
          sx={{ marginTop: "40px" }}
          disableRowSelectionOnClick
          paginationModel={pagination}
          onPaginationModelChange={setPagination}
          onSortModelChange={setGridSorting}
        />
      </Box>
    </Flex>
  );
};

export default PatientForms;
